import React from "react";

// Minimal inline formatter: **bold**, _italic_, [label](url)
export function formatInline(text) {
  if (text == null) return null;
  let k = 0;
  const key = () => `f${k++}`;
  const rec = (t) => {
    if (!t) return [];
    const patterns = [
      { type: "strong", re: /\*\*([\s\S]+?)\*\*/ },
      { type: "link", re: /\[([^\]]+)\]\(([^)]+)\)/ },
      { type: "em", re: /_([^_]+?)_/ },
    ];
    let best = null;
    for (const p of patterns) {
      const m = p.re.exec(t);
      if (m && (best === null || m.index < best.m.index)) best = { p, m };
    }
    if (!best) return [t];
    const { p, m } = best;
    const out = [];
    const before = t.slice(0, m.index);
    if (before) out.push(before);
    if (p.type === "strong") out.push(<strong key={key()}>{rec(m[1])}</strong>);
    else if (p.type === "em") out.push(<em key={key()}>{rec(m[1])}</em>);
    else
      out.push(
        <a
          key={key()}
          href={m[2]}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:opacity-80"
        >
          {rec(m[1])}
        </a>
      );
    return out.concat(rec(t.slice(m.index + m[0].length)));
  };
  return rec(text);
}
